import { AutocompleteProps, default as MuiBaseAutocomplete } from '@mui/material/Autocomplete'

import { COLORS, styled } from '../../theme'
import { createComponentWrapperWithRef, THEME_CONST } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

type Props = AutocompleteProps<any, boolean | undefined, boolean | undefined, boolean | undefined> & {
  $hasPrefix?: boolean
  severity?: keyof typeof COLORS.validation
  readOnly?: boolean
}

const MuiAutocomplete: MsdkStyledComponent<Props> = styled(MuiBaseAutocomplete, {
  shouldForwardProp: (prop) => prop !== 'severity' && prop !== 'readonly' && prop !== '$hasPrefix',
})<{
  $hasPrefix?: boolean
  severity?: keyof typeof COLORS.validation
  readOnly?: boolean
}>`
  .MuiInputBase-root {
    border-radius: ${THEME_CONST.inputBorderRadius}px;
  }
`
const NovaAutocomplete: MsdkStyledComponent<Props> = styled(MuiBaseAutocomplete, {
  shouldForwardProp: (prop) => prop !== 'severity' && prop !== 'readonly' && prop !== '$hasPrefix',
})<{
  $hasPrefix?: boolean
  severity?: keyof typeof COLORS.validation
  readOnly?: boolean
}>`
  && .MuiOutlinedInput-root:not(:hover) .MuiOutlinedInput-notchedOutline,
  && .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${(props) =>
      props.severity &&
      props.severity !== 'none' &&
      !props.disabled &&
      !props.readOnly &&
      COLORS.validation[props.severity].border} !important;
  }

  && .MuiInputLabel-root,
  && .MuiInputLabel-root.Mui-focused {
    color: ${(props) =>
      props.severity &&
      props.severity !== 'none' &&
      !props.disabled &&
      !props.readOnly &&
      COLORS.validation[props.severity].main} !important;
  }
`

export const Autocomplete = createComponentWrapperWithRef(
  {
    mui: MuiAutocomplete,
    nova: NovaAutocomplete,
  },
  'Autocomplete',
)
